import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const ProjectContext = createContext({
  projects: [],
  projectId: "__all",
  setProjectId: () => {},
  refresh: () => {},
});

const STORAGE_KEY = "ubbs_active_project_id";

export function ProjectProvider({ children }) {
  const [projects, setProjects] = useState([]);
  const [projectId, _setProjectId] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || "__all";
  });

  const setProjectId = useCallback((v) => {
    _setProjectId(v);
    if (v && v !== "__all") {
      localStorage.setItem(STORAGE_KEY, v);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/admin/projects");
      setProjects(r.data);
      // If the stored projectId no longer exists, reset to "all"
      const ids = new Set(r.data.map((p) => p.id));
      if (projectId !== "__all" && !ids.has(projectId)) {
        setProjectId("__all");
      }
    } catch {
      /* swallow */
    }
  }, [projectId, setProjectId]);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProjectContext.Provider value={{ projects, projectId, setProjectId, refresh }}>
      {children}
    </ProjectContext.Provider>
  );
}

export const useProject = () => useContext(ProjectContext);

/**
 * Helper: append the active project_id to a query-string object so every page
 * stays in sync with the global switcher.
 */
export function withProjectParam(params, projectId) {
  if (projectId && projectId !== "__all") {
    return { ...params, project_id: projectId };
  }
  return params;
}
